import { render } from "./HomeworkView.vue?vue&type=template&id=7568d585&scoped=true"
import script from "./HomeworkView.vue?vue&type=script&lang=js"
export * from "./HomeworkView.vue?vue&type=script&lang=js"

import "./HomeworkView.vue?vue&type=style&index=0&id=7568d585&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7568d585"]])

export default __exports__